import { useNavigate, useLocation } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [["how","How it works"],["api","API Docs"],["pricing","Pricing"],["order","Quick Delivery"]];

  return (
    <footer style={{
      borderTop: "1px solid var(--border)",
      padding: "48px 6% 32px",
    }}>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 32,
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: 32,
      }}>
        {/* Logo */}
        <img src="/logo.png" alt="Kwikie Express" style={{ height: 48, width: "auto", display: "block" }} />

        {/* Links grid — wraps naturally on mobile */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
          gap: "12px 24px",
          flex: 1,
          minWidth: 240,
        }}>
          {links.map(([id, label]) => (
            <button key={id} onClick={() => scrollTo(id)}
              style={{ background:"none", border:"none", fontSize:13, color:"var(--text3)", cursor:"pointer", fontFamily:"var(--font-body)", textAlign:"left", padding:0 }}
              onMouseOver={e=>e.target.style.color="var(--text)"} onMouseOut={e=>e.target.style.color="var(--text3)"}>
              {label}
            </button>
          ))}
          <a href="mailto:support@kwikie.app"
            style={{ fontSize:13, color:"var(--text3)", textDecoration:"none" }}
            onMouseOver={e=>e.target.style.color="var(--text)"} onMouseOut={e=>e.target.style.color="var(--text3)"}>
            Support
          </a>
          <a href="mailto:business@kwikie.app"
            style={{ fontSize:13, color:"var(--text3)", textDecoration:"none" }}
            onMouseOver={e=>e.target.style.color="var(--text)"} onMouseOut={e=>e.target.style.color="var(--text3)"}>
            Business
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        fontSize: 12,
        color: "var(--text3)",
        borderTop: "1px solid var(--border)",
        paddingTop: 20,
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        alignItems: "center",
      }}>
        © 2026 KwiKie Delivery. Built for Ghana 🇬🇭 | Powered by{" "}
        <a href="https://smaiz.dev" target="_blank" rel="noopener noreferrer"
          style={{ color:"var(--text2)" }}>
          Smaiz
        </a>
      </div>
    </footer>
  );
}